import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-5 pb-5 bg-white" }
const _hoisted_2 = { class: "px-3 pb-3 text-size-14" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "雇用主", -1)
const _hoisted_4 = { class: "text-mild" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "被用者", -1)
const _hoisted_6 = { class: "text-mild" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "契約形態", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dd", { class: "text-mild" }, "雇用契約(労災保険の対象)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "雇用契約", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dd", { class: "text-mild" }, "\n          勤務開始の1時間前に改めて労働条件通知書が送付され、その時点で雇用契約締結となります。\n        ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "勤務地", -1)
const _hoisted_12 = { class: "text-mild" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "業務日時", -1)
const _hoisted_14 = { class: "text-mild" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "業務報酬", -1)
const _hoisted_16 = { class: "text-mild" }
const _hoisted_17 = {
  key: 0,
  class: "text-mild"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "前日確認", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dd", { class: "text-mild" }, [
  /*#__PURE__*/_createTextVNode("\n          勤務の可否を確認するため、お仕事の前日にアプリを起動し、「勤務確定」をお願いします。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n          前日に「勤務確定」されない場合、お仕事がキャンセルされる可能性がございますので、ご注意ください。\n        ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "出退勤", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dd", { class: "text-mild" }, "\n          業務当日に、業務先のQRコードを「仕事管理」からQRコードリーダーで読み取り、出退勤してください。\n        ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", { class: "pt-3 text-weight-500" }, "報酬受取", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "modal-responsive-medium text-danger" }, "\n        ⚠応募ミスのキャンセルも信用スコアが減点されます\n      ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "modal-responsive-large" }, [
  /*#__PURE__*/_createElementVNode("u", null, "業務日時")
], -1)
const _hoisted_26 = { class: "modal-responsive-large" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_RewardDescription = _resolveComponent("RewardDescription")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      最終確認\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("dl", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(),
        _createElementVNode("dd", _hoisted_4, _toDisplayString(_ctx.orderDetail.office.name), 1),
        _createTextVNode(),
        _hoisted_5,
        _createTextVNode(),
        _createElementVNode("dd", _hoisted_6, _toDisplayString(`${_ctx.user.lastName} ${_ctx.user.firstName}`), 1),
        _createTextVNode(),
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8,
        _createTextVNode(),
        _hoisted_9,
        _createTextVNode(),
        _hoisted_10,
        _createTextVNode(),
        _hoisted_11,
        _createTextVNode(),
        _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.orderDetail.address), 1),
        _createTextVNode(),
        _hoisted_13,
        _createTextVNode(),
        _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.formattedDate) + " " + _toDisplayString(_ctx.formattedWorkTimeRange), 1),
        _createTextVNode(),
        _hoisted_15,
        _createTextVNode(),
        _createElementVNode("dd", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.salaryPerDayWithVariousAllowances) + "円\n          ", 1),
          (_ctx.orderDetail.variousAllowances > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "\n            (交通費" + _toDisplayString(_ctx.orderDetail.variousAllowances.toLocaleString()) + "円込み)\n          ", 1))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        _hoisted_18,
        _createTextVNode(),
        _hoisted_19,
        _createTextVNode(),
        _hoisted_20,
        _createTextVNode(),
        _hoisted_21,
        _createTextVNode(),
        _hoisted_22,
        _createTextVNode(),
        _createElementVNode("dd", null, [
          _createVNode(_component_RewardDescription)
        ])
      ]),
      _createTextVNode(),
      _createVNode(_component_OrderFixedButton, {
        isDisabled: _ctx.isExecuting,
        abTestGroup3300: _ctx.abTestGroup3300,
        enabledVariant: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$bvModal.show('apply-datetime-confirm')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        申し込み完了\n      ")
        ], undefined, true),
        _: 1
      }, 8, ["isDisabled", "abTestGroup3300"])
    ]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      id: "apply-datetime-confirm",
      title: "業務日時に間違いはありませんか？",
      "header-class": "font-weight-bold modal-responsive-title",
      "cancel-title": "キャンセル",
      "cancel-variant": "gray-03",
      onOk: _ctx.onClickApply,
      centered: ""
    }, {
      default: _withCtx(() => [
        _hoisted_23,
        _createTextVNode(),
        _hoisted_24,
        _createTextVNode(),
        _hoisted_25,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formattedDate) + " " + _toDisplayString(_ctx.formattedWorkTimeRange), 1)
      ], undefined, true),
      _: 1
    }, 8, ["onOk"])
  ]))
}